import React from "react";

const PostpartumThankYouPopup = ({ onClose, onExplore }) => (
  <div className="modal show custom-modall" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header border-0">
          
          <button type="button" className="btn-close" onClick={onClose}></button>
        </div>
        <div className="modal-body text-center">
          <p style={{fontSize:"1.5rem"}}>
            Thank you for sharing this update with us!
          </p>
          <p>
            We're wishing you all the best as you navigate parenthood and we're here to support you every step of the way. As you navigate this next chapter, don't forget, you have a dedicated postpartum support program available to you.
          </p>
          <button
            className="win-btn-primary w-100 mt-3"
            onClick={onExplore}
          >
            Explore Maternity Resources
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default PostpartumThankYouPopup;